import { ChevronDown, ChevronLeftIcon, SearchIcon } from "lucide-react";
// @ts-ignore
import profileImg from '@assets/images/profilepic.png'
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { setJobDetail } from "@store/actions/job.action";
import dayjs from "@lib/dayjs";
import { EnumJobStatus2, JobStatus } from "@utils/constants";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";

const dummyData = [
    {
        "_id": "69d3b8846c65ecafd8730f3c",
        "title": "Sr. Front-end developer",
        "description": "<p>React developer</p>",
        "location": "London",
        "salary": {
            "min": 30000,
            "max": 50000
        },
        "workPlaceOption": 1,
        "industryType": "Software Development",
        "jobType": 1,
        "status": 2,
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": false,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-04-06T13:43:32.274Z",
        "updatedAt": "2026-04-06T13:44:36.101Z",
        "refNo": "JO-802QNI",
        "companyId": "694808c5cace2035254c7dae",
        "publishedDate": "2026-04-06T13:43:58.675Z",
        "showCompanyDetails": true,
        "referralAmount": null,
        "companyDetails": {
            "name": "One Piece Pvt Ltd",
            "refNo": "CO-FUSMST"
        },
        "latestTrackerDetails": {
            "_id": "69d3b9336c65ecafd8731118",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "69d3b9156c65ecafd87310d0",
            "status": "Submit Offer",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2026-04-06T13:46:27.178Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2026-04-06T13:45:57.062Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-05-06T13:43:58.675Z"
    },
    {
        "_id": "69a2ad658b0849d1ab2a1174",
        "title": "React Js Developer Test message",
        "description": "<p><br></p><p>sdfasdfa</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 1233
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 2,
        "jobRequirementId": "68bd90a23bdad972f42ea6d1",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": false,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-02-28T08:55:01.168Z",
        "updatedAt": "2026-03-01T13:14:24.050Z",
        "refNo": "JO-1I46WM",
        "publishedDate": "2026-02-28T08:55:04.151Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "69a44e8ecb84802503293a69",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "69a2addccb2371b4b389b405",
            "status": "Application Viewed",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2026-03-01T14:34:54.782Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2026-02-28T08:57:00.276Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-03-30T08:55:04.151Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "69932f8c419d7889aac476ea",
        "title": "Flutter Developer",
        "description": "<p><br></p><p>required full time flutter developer</p>",
        "location": "Ahmedabad",
        "salary": {
            "min": 12000,
            "max": 30000
        },
        "workPlaceOption": 1,
        "industryType": "mobile development",
        "jobType": 1,
        "status": 2,
        "jobRequirementId": "694925accace2035254ee12a",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": false,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-02-16T14:54:04.895Z",
        "updatedAt": "2026-02-16T14:54:44.911Z",
        "refNo": "JO-B9NLPQ",
        "publishedDate": "2026-02-16T14:54:43.098Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {},
        "totalApplicants": 0,
        "unViewedApplicants": 0,
        "latestApplicantAt": null,
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-03-18T14:54:43.098Z",
        "hiringCompany": {
            "_id": "6878dcf0dd6ccf4850c99c0c",
            "firstName": "samir",
            "lastName": "ambaliya",
            "companyName": "ashutec solution pvt ltd",
            "userType": 6,
            "userName": "SamirAmbaliya7772",
            "refNo": "HC-TP981J",
            "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/51a325b0-0c3b-41f5-8f8b-f2a33cc65000/public"
        }
    },
    {
        "_id": "6990a0351735e450cb3a2b05",
        "title": "React Js Developer",
        "description": "<p>This is the job description</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 1233
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 2,
        "jobRequirementId": "68bd90a23bdad972f42ea6d1",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": false,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-02-14T16:17:57.049Z",
        "updatedAt": "2026-02-16T14:53:35.038Z",
        "refNo": "JO-VTMRW1",
        "publishedDate": "2026-02-16T14:53:07.861Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {},
        "totalApplicants": 0,
        "unViewedApplicants": 0,
        "latestApplicantAt": null,
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-03-18T14:53:07.861Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "6968e76d2ee222e01e1b16d9",
        "title": "React Js Developer (Testing job match)",
        "description": "<p><br></p><p>sdfasdfa</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 1233
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "68bd90a23bdad972f42ea6d1",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-01-15T13:11:09.425Z",
        "updatedAt": "2026-02-14T03:30:03.207Z",
        "refNo": "JO-E9U02N",
        "publishedDate": "2026-01-15T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "698fec3b1735e450cb38b0b3",
            "candidateId": "6968e5a22ee222e01e1b1103",
            "jobApplicationId": "6973aefdf60c421108099b23",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2026-02-14T03:30:03.020Z",
            "candidateDetails": {
                "_id": "6968e5a22ee222e01e1b1103",
                "userId": "6968e57c2ee222e01e1b106b",
                "firstName": "Tony ",
                "lastName": "Candidate4",
                "status": "Available",
                "refNo": "CM-8XS0XF",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/a41cca65-875e-46c1-ba26-7e2118fea600/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2026-01-23T17:25:17.174Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-02-14T00:00:00.000Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "6964fe861d3ff60f0c78ed4d",
        "title": "React-Native Developer (Queue Test)",
        "description": "<p><br></p><p><span style=\"color: rgb(4, 81, 165); background-color: rgb(255, 255, 255);\">We are looking for a skilled React-Native Developer with React experience.</span></p>",
        "location": "Ahmedabad",
        "salary": {
            "min": 12000,
            "max": 30000
        },
        "workPlaceOption": 1,
        "industryType": "software development",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "69493ea9cace2035254f1716",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-01-12T14:00:38.111Z",
        "updatedAt": "2026-02-14T03:30:03.207Z",
        "refNo": "JO-H0APFF",
        "publishedDate": "2026-01-15T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "698fec3a1735e450cb38b0aa",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "6964fea91d3ff60f0c78ee75",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2026-02-14T03:30:02.015Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 3,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2026-01-12T14:17:20.713Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-02-14T00:00:00.000Z",
        "hiringCompany": {
            "_id": "6878dcf0dd6ccf4850c99c0c",
            "firstName": "samir",
            "lastName": "ambaliya",
            "companyName": "ashutec solution pvt ltd",
            "userType": 6,
            "userName": "SamirAmbaliya7772",
            "refNo": "HC-TP981J",
            "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/51a325b0-0c3b-41f5-8f8b-f2a33cc65000/public"
        }
    },
    {
        "_id": "6963beb55f6b7305ccee77a8",
        "title": "React Js Developer (Submission Queue)",
        "description": "<p><br></p><p>sdfasdfa</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 1233
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "68bd90a23bdad972f42ea6d1",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-01-11T15:16:05.059Z",
        "updatedAt": "2026-02-10T03:30:02.116Z",
        "refNo": "JO-4ZJZB5",
        "publishedDate": "2026-01-11T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "698aa6391c883944ea6931ae",
            "candidateId": "6968e5a22ee222e01e1b1103",
            "jobApplicationId": "6973af33f60c421108099be7",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2026-02-10T03:30:01.896Z",
            "candidateDetails": {
                "_id": "6968e5a22ee222e01e1b1103",
                "userId": "6968e57c2ee222e01e1b106b",
                "firstName": "Tony ",
                "lastName": "Candidate4",
                "status": "Available",
                "refNo": "CM-8XS0XF",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/a41cca65-875e-46c1-ba26-7e2118fea600/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 3,
        "unViewedApplicants": 1,
        "latestApplicantAt": "2026-01-23T17:26:11.844Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-02-10T00:00:00.000Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "69624f665f6b7305cceb645d",
        "title": "React Js Developer(Job List New UI)",
        "description": "<p><br></p><p>sdfasdfa</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 1233
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "68bd90a23bdad972f42ea6d1",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2026-01-10T13:08:54.550Z",
        "updatedAt": "2026-02-09T03:30:03.197Z",
        "refNo": "JO-52YKD7",
        "publishedDate": "2026-01-10T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "698954ba7de84b20585167cd",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "6964fd2f1d3ff60f0c78e86b",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2026-02-09T03:30:02.035Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 2,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2026-01-12T13:54:55.777Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-02-09T00:00:00.000Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "69457192cace20352546ed20",
        "title": "New Job",
        "description": "<p>this is job description</p>",
        "location": "United Kingdom",
        "salary": {
            "min": 21,
            "max": 345
        },
        "workPlaceOption": 1,
        "industryType": "IT",
        "jobType": 1,
        "status": 6,
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-12-19T15:38:58.639Z",
        "updatedAt": "2026-01-19T03:30:02.328Z",
        "refNo": "JO-D7LLPI",
        "publishedDate": "2026-01-12T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "69457d65cace203525470960",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "694571b7cace20352546ee51",
            "status": "Candidate Has Joined Hiring Company",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2025-12-19T16:29:25.236Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2025-12-19T15:39:35.792Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-02-11T00:00:00.000Z"
    },
    {
        "_id": "694252123357f443309a2eec",
        "title": "JR Team",
        "description": "<p>this is job description</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 12345
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-12-17T06:47:46.674Z",
        "updatedAt": "2026-01-17T03:30:05.587Z",
        "refNo": "JO-0EK1DF",
        "publishedDate": "2025-12-18T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {
            "_id": "69440c5c12d4f45ee460ca6b",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "6943c8012b5ffc98fea0c13d",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2025-12-18T14:14:52.147Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2025-12-18T09:23:13.766Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-01-17T00:00:00.000Z"
    },
    {
        "_id": "694025478890fa903874dd2b",
        "title": "Test Title",
        "description": "<p>this is job description</p>",
        "location": "United Kingdom",
        "salary": {
            "min": 12,
            "max": 12345
        },
        "workPlaceOption": 1,
        "industryType": "IT industry",
        "jobType": 1,
        "status": 6,
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-12-15T15:12:07.496Z",
        "updatedAt": "2026-01-15T03:30:04.793Z",
        "refNo": "JO-2495FK",
        "publishedDate": "2025-12-18T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "companyId": "694808c5cace2035254c7dae",
        "companyDetails": {
            "name": "One Piece Pvt Ltd",
            "refNo": "CO-FUSMST"
        },
        "latestTrackerDetails": {
            "_id": "69440c8a12d4f45ee460cb0d",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "6943c9212b5ffc98fea0c5c2",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2025-12-18T14:15:38.203Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2025-12-18T09:28:01.038Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-01-17T00:00:00.000Z"
    },
    {
        "_id": "692c7fbecbd9f81576234d31",
        "title": "Referral Balance",
        "description": "<p><br></p><p>wrerwqreeq</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 234234
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "68b916fc3d7d9360782f52bf",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-11-30T17:32:46.261Z",
        "updatedAt": "2025-12-31T03:30:02.297Z",
        "refNo": "JO-P913UV",
        "publishedDate": "2025-11-30T00:00:00.000Z",
        "referralAmount": 500,
        "showCompanyDetails": false,
        "latestTrackerDetails": {
            "_id": "692c803dcbd9f81576234fd7",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "692c8012cbd9f81576234f6e",
            "status": "Candidate Placed",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2025-11-30T17:34:53.365Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2025-11-30T17:34:10.951Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2025-12-30T00:00:00.000Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "69286efdbffc902ebd4b1791",
        "title": "ReactJs Developer",
        "description": "<p>this is job description</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 234234
        },
        "workPlaceOption": 2,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-11-27T15:32:13.385Z",
        "updatedAt": "2025-12-28T03:30:03.599Z",
        "refNo": "JO-N3FN89",
        "publishedDate": "2025-12-18T00:00:00.000Z",
        "referralAmount": 20,
        "showCompanyDetails": false,
        "latestTrackerDetails": {
            "_id": "69440f2012d4f45ee460d2d4",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "6939a4027a6e8f3f05669610",
            "status": "Job Close",
            "createdBy": "68b9150e3d7d9360782f4f90",
            "createdAt": "2025-12-18T14:26:40.223Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "68b9150e3d7d9360782f4f90",
                "firstName": "Adele",
                "lastName": "Employers",
                "companyName": "Adele Inc.",
                "userType": 2,
                "refNo": "RE-6AY257",
                "userName": "AdeleEmployer",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/138fbf31-c9b0-4773-6894-5a098400bb00/public"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2025-12-10T16:46:58.963Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-01-17T00:00:00.000Z"
    },
    {
        "_id": "69286263bffc902ebd4af91f",
        "title": "Test Job 2",
        "description": "<p><br></p><p>wrerwqreeq</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 234234
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "68b916fc3d7d9360782f52bf",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-11-27T14:38:27.692Z",
        "updatedAt": "2025-12-28T03:30:03.599Z",
        "refNo": "JO-KTTSVX",
        "publishedDate": "2025-12-17T00:00:00.000Z",
        "showCompanyDetails": false,
        "referralAmount": null,
        "latestTrackerDetails": {},
        "totalApplicants": 0,
        "unViewedApplicants": 0,
        "latestApplicantAt": null,
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2026-01-16T00:00:00.000Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    },
    {
        "_id": "691f4055cd1480df47f0fa44",
        "title": "Test Job - Activity Tracker",
        "description": "<p><br></p><p>wrerwqreeq</p>",
        "location": "London",
        "salary": {
            "min": 123,
            "max": 234234
        },
        "workPlaceOption": 1,
        "industryType": "It",
        "jobType": 1,
        "status": 6,
        "jobRequirementId": "68b916fc3d7d9360782f52bf",
        "createdBy": "68b9150e3d7d9360782f4f90",
        "isSalaryHidden": false,
        "extensionNotified": true,
        "hasReferral": false,
        "currency": "£",
        "positionLevel": 4,
        "isStartUp": false,
        "isInternship": false,
        "createdAt": "2025-11-20T16:22:45.416Z",
        "updatedAt": "2025-12-21T03:30:02.935Z",
        "refNo": "JO-DD8WLC",
        "publishedDate": "2025-11-20T00:00:00.000Z",
        "referralAmount": 12,
        "showCompanyDetails": false,
        "latestTrackerDetails": {
            "_id": "6939a21b7a6e8f3f05669065",
            "candidateId": "67d5a95cc4341e7db96dd3eb",
            "jobApplicationId": "69247bcb435c284e97593f2d",
            "status": "Confirm Exclusive Representation",
            "createdBy": "67d5a945c4341e7db96dd3ab",
            "createdAt": "2025-12-10T16:38:51.927Z",
            "candidateDetails": {
                "_id": "67d5a95cc4341e7db96dd3eb",
                "userId": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "status": "Available",
                "refNo": "CM-8ED7Y4",
                "profilePic": "https://imagedelivery.net/GASHEXe_7q8VSc7ZloC3oQ/bece3ce5-8b70-4132-265f-b4644dc6d800/public"
            },
            "createdByDetails": {
                "_id": "67d5a945c4341e7db96dd3ab",
                "firstName": "Tony",
                "lastName": "Candidate Test",
                "companyName": "",
                "userType": 3,
                "userName": "TonyCandidate1062"
            }
        },
        "totalApplicants": 1,
        "unViewedApplicants": 0,
        "latestApplicantAt": "2025-11-24T15:37:47.436Z",
        "recruiterAgencyName": "Adele Inc.",
        "expiredAt": "2025-12-20T00:00:00.000Z",
        "hiringCompany": {
            "_id": "689b5345b3cb6e32b9626c4e",
            "firstName": "Brad Test",
            "lastName": "Hiring",
            "companyName": "Brad Tech Pvt Ltd.",
            "userType": 6,
            "refNo": "HC-FSOGFP",
            "userName": "BradHiring"
        }
    }
]


export function getStatusColors({ status }: { status: EnumJobStatus2 }) {
    switch (status) {
        case EnumJobStatus2.LIVE:
            return 'border-[#99CA60]'
        case EnumJobStatus2.EXPIRED:
            return 'border-[#6f6f6f]'
        default:
            return 'border-black'
    }
}

export function getStatusTextColors({ status }: { status: EnumJobStatus2 }) {
    switch (status) {
        case EnumJobStatus2.LIVE:
            return 'text-[#99CA60]'
        case EnumJobStatus2.EXPIRED:
            return 'text-[#6f6f6f]'
        default:
            return 'text-black'
    }
}

const JobCard = ({ data }) => {
    const dispatch = useDispatch();
    const isClosed = data?.status === JobStatus.CLOSED && "Closed";

    return (
        <NavLink
            to={`/job/${data?._id}/applicants`}
            state={data}
            onClick={() => {
                dispatch(setJobDetail(data));
                // navigate(`/job/${data?._id}/applicants`, { state: data });
            }}
            className="grid grid-cols-[1.4fr_1.3fr_0.2fr] gap-12 justify-between bg-white border-b border-[#ececec] rounded px-3 py-5 hover:bg-slate-50 cursor-pointer"
        >
            <div className="flex flex-col gap-1">
                <div className="flex items-center justify-between">
                    <span className="text-[10px] text-light-black font-medium pl-2">
                        {data?.refNo}
                    </span>
                    <span className={`flex justify-center items-center font-medium text-[10px] ${getStatusTextColors({ status: data?.status })}`}> {data?.status === JobStatus.LIVE && "Live"}
                        {data?.status === JobStatus.DRAFT && "Draft"}
                        {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
                        {data?.status === JobStatus.CLOSED && "Closed"}
                        {data?.status === JobStatus.EXPIRED && "Expired"}
                    </span>
                </div>
                <div className={`flex flex-col gap-1 rounded-md py-3 px-5 border border-y-gray-100 border-r-gray-100 ${getStatusColors({ status: data?.status })} border-l-[3px]`}>
                    <span className="text-xs font-bold text-primary line-clamp-1">{data?.title}</span>
                    <span className="text-xss font-medium text-light-black">Hiring Company:&nbsp;&nbsp;&nbsp;<span className="font-medium text-primary">{data?.hiringCompany?.companyName || 'N/A'}</span></span>
                </div>
                <div className="flex items-center justify-between pl-2">
                    <div className="flex items-center gap-2">
                        <span className="text-[10px] text-gray-400 font-medium">
                            Published:
                        </span>
                        <span className="text-[10px] text-primary italic font-medium">
                            {data?.publishedDate &&
                                dayjs(data?.publishedDate).format("hh:mm a Do MMM YY")}
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-[10px] text-gray-400 font-medium">
                            {isClosed ? "Closed" : "Expiring"}:
                        </span>
                        <span className="text-[10px] text-primary italic font-medium">
                            {dayjs(isClosed ? data?.updatedAt : data?.expiredAt).format(
                                "hh:mm a Do MMM YY"
                            )}
                        </span>
                    </div>
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-5 h-[1rem]">
                    {
                        data?.latestTrackerDetails?.createdAt ?
                            <>
                                <span className="text-xss text-light-black font-medium italic">
                                    {dayjs(data?.latestTrackerDetails?.createdAt).format("hh:mm a")}
                                </span>
                                <span className="text-xss text-light-black font-medium italic">
                                    {dayjs(data?.latestTrackerDetails?.createdAt).format("DD MMM YYYY")}
                                </span>
                            </>
                            :
                            null
                    }
                </div>

                <div className="flex items-center bg-light-white-700 border border-gray-200 rounded-md h-[3.8rem] py-3 px-3">
                    <span className="text-xs font-medium text-primary">
                        Latest Activity : {data?.latestTrackerDetails?.status || 'N/A'}
                    </span>
                </div>
            </div>

            <div className="flex flex-col text-xss gap-2">
                Matched
                <div className="relative">
                    <AnimatedCircleProgress
                        progress={79}
                        strokeWidth={2}
                        textStyle="font-semibold text-primary"
                    />
                </div>
            </div>
        </NavLink>
    );
};

const CandidateAppliedJobPage = () => {
    const navigate = useNavigate();

    return <div className="flex flex-col flex-1 rounded-md bg-white p-5 min-h-0">
        <button
            onClick={() => navigate('/job/by-candidate')}
            className="flex items-center self-start gap-1"
        >
            <ChevronLeftIcon className={"w-4 h-4"} />
            <label className="text-xs font-medium text-primary cursor-pointer">
                Back to listing
            </label>
        </button>

        {/* Candidate details section */}
        <div className="flex flex-col px-4 min-h-0">
            <div className="flex items-center gap-7 bg-[#fafafa] mt-5 border  py-3 px-5">
                <div className="h-[64px] w-[64px] rounded-full">
                    <img src={profileImg} className="h-full w-full" />
                </div>
                <div className="flex flex-col gap-1.5 text-[#4d4d4d]">
                    <span className="border-b-[1px] border-primary text-lg font-medium tracking-[0.25rem] w-max pr-3">Bob Smith</span>
                    <span className="text-xs font-medium">Senior Application Developer</span>
                </div>
            </div>

            {/* Main section */}
            <div className="flex flex-col py-3.5 px-3 min-h-0">
                {/* Search sections */}
                <div className="flex items-center gap-10 border-b pb-4">
                    <div className="flex items-center border rounded-md px-3 h-9 bg-light-white-700">
                        <input
                            className="outline-none text-xs font-medium bg-transparent w-48"
                            placeholder="Search"
                        />
                        <SearchIcon color="gray" size={14} />
                    </div>

                    <div className="flex items-center h-9 border rounded-md gap-10 pl-4 pr-1">
                        <span className="text-xs font-medium text-primary">Sort by : Most recent update</span>
                        <ChevronDown color="#2e2e2e" size={18} />
                    </div>
                </div>

                {/* Listing section  */}
                <div className="flex flex-col min-h-0">
                    {
                        dummyData?.map((job) => {
                            return <JobCard
                                key={job?._id}
                                data={job}
                            />
                        })
                    }
                </div>
            </div>
        </div>
    </div>
}

export default CandidateAppliedJobPage;